import CreditLimit from './creditLimit'

export default CreditLimit
